interface WebEnvironment {
  VITE_API_URL: string
  VITE_ALLOWED_HOSTS: string
}

const requiredKeys = ['VITE_API_URL', 'VITE_ALLOWED_HOSTS'] as const

export function getWebEnvironment(): WebEnvironment {
  const missing = requiredKeys.filter((key) => !import.meta.env[key])
  if (missing.length > 0) {
    throw new Error(
      `Missing required environment variables: ${missing.join(', ')}. Copy apps/web/.env.template to apps/web/.env.`
    )
  }

  return {
    VITE_API_URL: import.meta.env.VITE_API_URL,
    VITE_ALLOWED_HOSTS: import.meta.env.VITE_ALLOWED_HOSTS,
  }
}
